export default "__VITE_ASSET__CItjhUT9__"